import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonagpurcab() {



const cardData = {
  keyword: " Mumbai to Nagpur Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Nagpur cab services, ensuring a smooth and hassle-free journey for business trips, family travel, and sightseeing tours. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Aurangabad convenient and stress-free. The journey covers approximately 335–350 km via the Mumbai–Aurangabad Highway, typically taking 6–7 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Aurangabad cab travel.",

topPlaces: [
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves are UNESCO World Heritage rock-cut caves near Aurangabad, famous for ancient Buddhist murals and sculptures. Travelers from Mumbai can visit this historic site comfortably by cab, explore the intricate carvings, and learn about the rich cultural heritage of India."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves is a UNESCO World Heritage site comprising Buddhist, Hindu, and Jain rock-cut temples. Visitors traveling by cab from Mumbai can admire the architectural marvels, explore the monasteries, and enjoy guided tours of this historic destination."
  },
  {
    title: "Bibi Ka Maqbara",
    description: "Bibi Ka Maqbara, often called the ‘Mini Taj Mahal,’ is a historic mausoleum in Aurangabad. Travelers using a cab from Mumbai can explore its beautiful Mughal architecture, take photographs, and learn about the history behind this iconic structure."
  },
  {
    title: "Aurangabad Caves",
    description: "Aurangabad Caves are a set of rock-cut Buddhist caves located on a hill near the city. Travelers can visit these caves comfortably by cab from Mumbai, explore the ancient carvings and sculptures, and enjoy scenic views of the surrounding landscape."
  },
  {
    title: "Daulatabad Fort",
    description: "Daulatabad Fort is a historic hill fort near Aurangabad, known for its strategic architecture and panoramic views. Visitors from Mumbai can reach the fort easily by cab, explore its strong walls and gates, and enjoy the trekking trails around the fort."
  },
  {
    title: "Grishneshwar Temple",
    description: "Grishneshwar Temple is a revered Hindu temple near Aurangabad, dedicated to Lord Shiva. Travelers arriving from Mumbai by cab can visit the temple comfortably, participate in rituals, and admire the beautiful architecture and spiritual atmosphere."
  },
  {
    title: "Panchakki",
    description: "Panchakki is an ancient water mill and historical site in Aurangabad. Visitors traveling from Mumbai by cab can explore the unique engineering of the water mill, enjoy the landscaped gardens, and learn about the history behind this site."
  },
  {
    title: "Siddharth Garden & Zoo",
    description: "Siddharth Garden & Zoo is a recreational park in Aurangabad, offering green spaces, animal exhibits, and leisure activities. Travelers from Mumbai can enjoy a comfortable ride by cab and spend a relaxing day amidst nature and wildlife."
  },
  {
    title: "Himroo Factory",
    description: "Himroo Factory in Aurangabad is known for traditional Himroo textiles and handicrafts. Travelers using a cab from Mumbai can visit the factory, shop for unique fabrics, and experience local craftsmanship and culture."
  },
  {
    title: "Salim Ali Lake",
    description: "Salim Ali Lake is a scenic spot in Aurangabad, ideal for bird watching, photography, and nature walks. Travelers from Mumbai can take a cab to this tranquil location, enjoy the peaceful environment, and capture beautiful moments in the lush surroundings."
  }
],



services: [
{
name: "Mumbai to Aurangabad Cab Service",
description: "Mumbai to Aurangabad cab service offers a comfortable and reliable long-distance travel option for tourists, families, and business travelers. This route is highly popular for visiting world-famous attractions like Ajanta and Ellora Caves, Bibi Ka Maqbara, and other historical sites. The journey from Mumbai to Aurangabad is smooth with well-connected highways, making it ideal for road trips. Professional drivers ensure safe driving and timely arrival while maintaining high service standards. Customers can choose from a wide range of vehicles including sedan, SUV, and premium cars based on their travel needs. Doorstep pickup and drop across Mumbai and Aurangabad ensure maximum convenience. With transparent pricing, flexible travel schedules, and 24x7 availability, this cab service ensures a hassle-free and enjoyable journey."
},
{
name: "Mumbai to Aurangabad Taxi",
description: "Mumbai to Aurangabad taxi service provides dependable and comfortable transportation for long-distance travel. This service is perfect for travelers who prefer a private journey with flexible travel timing. Vehicles are well-maintained with clean interiors and comfortable seating. Drivers are experienced in highway routes, ensuring a safe and smooth ride. Multiple vehicle options such as sedan and SUV are available for different budgets. Flexible pickup locations across Mumbai add convenience. It ensures a comfortable and stress-free journey."
},
{
name: "One Way Cab Mumbai to Aurangabad",
description: "One way cab Mumbai to Aurangabad is a cost-effective solution for travelers who need a single-side drop without return charges. This service is ideal for tourists, business travelers, and personal trips. Customers benefit from competitive pricing and flexible pickup timing. Professional drivers ensure safe and timely travel. Multiple vehicle options including sedan and SUV are available. Online booking with instant confirmation adds convenience. It is an affordable and practical travel option."
},
{
name: "Mumbai to Aurangabad Cab Booking",
description: "Mumbai to Aurangabad cab booking allows customers to reserve their ride quickly with instant confirmation and flexible scheduling. Travelers can choose vehicle type, pickup time, and drop location based on their needs. Transparent pricing ensures no hidden charges. Online booking platforms provide secure payment options and real-time availability. Dedicated customer support is available for assistance. This service ensures a smooth and organized travel experience. It is the easiest way to plan your journey."
},
{
name: "Mumbai to Aurangabad Taxi Fare",
description: "Mumbai to Aurangabad taxi fare is designed to be transparent and budget-friendly, helping travelers plan their trip efficiently. Pricing depends on vehicle type, travel distance, and trip duration. Customers receive a clear breakdown of costs including tolls and driver allowance where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. Flexible pricing suits different budgets. It offers great value for long-distance travel."
},
{
name: "Cheap Cab Mumbai to Aurangabad",
description: "Cheap cab Mumbai to Aurangabad offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers seeking reliable transportation. Sedan vehicles provide economical pricing for long-distance travel. Transparent billing ensures no hidden charges. Professional drivers ensure smooth and safe travel. Flexible booking options make planning easy. It is a perfect option for affordable travel."
},
{
name: "Mumbai to Aurangabad Outstation Cab",
description: "Mumbai to Aurangabad outstation cab service provides reliable intercity travel with comfort and safety. This service is suitable for tourists, families, and business travelers. Vehicles are well-maintained for long-distance highway travel. Flexible options include one way and round trip packages. Professional drivers ensure safe navigation and timely arrival. Pickup from multiple locations in Mumbai adds convenience. It ensures a hassle-free journey experience."
},
{
name: "Mumbai to Aurangabad SUV Taxi",
description: "Mumbai to Aurangabad SUV taxi is ideal for families and groups who need extra space and comfort during travel. SUVs offer spacious seating and better road performance for long journeys. This option is suitable for long-distance trips with luggage and multiple passengers. Professional drivers ensure safe and comfortable travel. It provides a premium travel experience. Perfect for group travel. It ensures a smooth and enjoyable ride."
},
{
name: "Mumbai to Aurangabad Sedan Cab",
description: "Mumbai to Aurangabad sedan cab is a popular choice for individuals, couples, and small families seeking a comfortable and economical ride. Sedans provide smooth travel, good mileage, and comfortable seating for long-distance journeys. This service is ideal for budget-friendly travel. Professional drivers ensure safe and efficient driving. Flexible pickup options enhance convenience. It ensures a pleasant journey experience."
},
{
name: "Mumbai to Aurangabad Car Rental",
description: "Mumbai to Aurangabad car rental service provides flexible travel options with a wide range of vehicles to choose from. Customers can rent cars for one way or round trips based on their requirements. This service is suitable for family trips, corporate travel, and tourism. Easy booking process and transparent pricing make it convenient. Vehicles are clean and well-maintained with professional drivers. Flexible pickup options ensure convenience. It ensures a customized travel experience."
},
{
name: "Private Cab Mumbai to Aurangabad",
description: "Private cab Mumbai to Aurangabad offers a personalized travel experience with exclusive vehicle usage. Travelers can customize routes, stops, and travel schedules based on their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service. Comfortable seating and premium service enhance the experience. It is ideal for private and luxury travel. It guarantees comfort and flexibility."
},
{
name: "AC Taxi Mumbai to Aurangabad",
description: "AC taxi Mumbai to Aurangabad ensures a comfortable journey in air-conditioned vehicles for long-distance travel. This service provides a cool and pleasant environment throughout the journey. Clean interiors and well-maintained AC systems enhance comfort. Suitable for families, tourists, and business travelers. Flexible booking options make planning easy. Professional drivers ensure timely service. It guarantees a relaxing travel experience."
},
{
name: "Book Mumbai to Aurangabad Cab Online",
description: "Book Mumbai to Aurangabad cab online for quick and hassle-free reservations with instant confirmation. Customers can select vehicle type, pickup time, and drop location easily. Secure payment options and transparent pricing ensure smooth booking. This service ensures vehicle availability even during peak travel seasons. Dedicated support is available anytime. It simplifies travel planning for long-distance trips. It is the most convenient booking option."
}
],

tableData: [
["Mumbai to Aurangabad Cab Service","Mumbai to Aurangabad Taxi"],
["One Way Cab Mumbai to Aurangabad","Mumbai to Aurangabad Cab Booking"],
["Mumbai to Aurangabad Taxi Fare","Cheap Cab Mumbai to Aurangabad"],
["Mumbai to Aurangabad Outstation Cab","Mumbai to Aurangabad SUV Taxi"],
["Mumbai to Aurangabad Sedan Cab","Mumbai to Aurangabad Car Rental"],
["Private Cab Mumbai to Aurangabad","AC Taxi Mumbai to Aurangabad"],
["Book Mumbai to Aurangabad Cab Online","Mumbai to Aurangabad Cab Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Long Distance Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mumbai to Nagpur cab service for a smooth and comfortable journey, ideal for family trips, business travel, and long-distance travel across Maharashtra."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Nagpur highway routes, ensuring safe driving, proper route navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Nagpur cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Nagpur cab service operates 24/7. Whether you plan early morning travel or overnight journeys, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and multi-day travel plans between Mumbai and Nagpur."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Nagpur cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Nagpur cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Nagpur for one-way and round-trip travel." },
  { question: "How far is Nagpur from Mumbai?", answer: "The distance between Mumbai and Nagpur is approximately 820 to 850 km and travel time is around 14 to 16 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Nagpur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Nagpur." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Nagpur cabs online or through phone booking." },
  { question: "Is overnight travel possible?", answer: "Yes, many customers prefer overnight travel for this route and our drivers are experienced for long-distance night journeys." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance routes like Mumbai to Nagpur." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Deshmukh",
    feedback:
      "A long-distance journey from Mumbai to Nagpur that was handled very comfortably. The cab was well-maintained, and the ride remained smooth and relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Mumbai to Nagpur cab service was reliable and well-organized. The vehicle was clean, the drive was steady, and the overall travel experience felt safe and comfortable.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const mumbaiNagpurSamruddhiCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Nagpur via Samruddhi Mahamarg Cab Service | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Nagpur via Samruddhi Mahamarg for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Nagpur Samruddhi Mahamarg Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Nagpur via Samruddhi Mahamarg",
        "description": "Private cab from Mumbai to Nagpur via Samruddhi Expressway for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Nagpur via Samruddhi Mahamarg",
        "description": "Comfortable round-trip cab service from Mumbai to Nagpur via Samruddhi Mahamarg with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};




  return (
    <div>
      <Helmet>
  <title>Mumbai to Nagpur via Samruddhi Mahamarg Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Nagpur via Samruddhi Mahamarg for comfortable outstation travel. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiNagpurSamruddhiCabJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonagpurcab;